import React from 'react';
import './Home.css';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Contact from './Contact';
import Vorteile from './Vorteile';
import FAQ from './FAQ';
import ReactCompareImage from "react-compare-image";
import banner1 from '../assets/images/banner1.jpg';
import banner1Before from '../assets/images/banner1-before.jpg';
import banner5Before from '../assets/images/banner5-before.jpg';
import banner5After from '../assets/images/banner5-after.jpg';
import banner6Before from '../assets/images/banner6-before.jpg';
import banner6After from '../assets/images/banner6-after.jpg';

const Home = () => {
    return(
        <div>
            <Hero />
            <About />
            <Services />
            <Vorteile />
                <h1 className='voherH1'>Vorher/Nachher</h1>
                <div className="mainWrapper">
                    <div className="contentWrapper">
                        <ReactCompareImage leftImage={banner1Before} rightImage={banner1} />
                        <ReactCompareImage leftImage={banner6Before} rightImage={banner6After} />
                        <ReactCompareImage leftImage={banner5Before} rightImage={banner5After} />
                    </div>
                </div>
            <FAQ />
            <Contact />
        </div>
    );
};

export default Home;